import { globalStyles } from 'shared/constants';

const style = {
  errorTitle: {
    color: 'grey.700',
  },
  tableWrapper: {
    border: '1px solid',
    borderColor: 'grey.200'
  },
  contenWrapper: {
    padding: '16px 24px 0!important',
  },
  gridErrorWrapper: {
    marginBottom: '12px!important'
  }
};

export default style;
